import React, { useState } from "react";
import "./styles.sass";
import assets from "../../assets";
import { Pagination } from "../pagination";
import useHandler from "./handler";

export const SchoolManagement = () => {
  const {
    schoolList,
    search,
    setSearch,
    getSchoolManagementLisit,
    onChangeValue,
    refreshData,
    loading,
    getSelectedSchools,
    clearSelectedSchools,
    data,
    handleCheckboxChange,
  } = useHandler();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const totalSchools = schoolList?.length || 0;

  const schools = getSelectedSchools();

  const STUNDET_ACTIVITY_DETAILS = [
    {
      icon: assets.ic_persons,
      title: "Total School",
      noOfSchool: totalSchools,
    },
  ];

  const students = Array.from({ length: 25 }, (_, i) => ({
    id: i + 1,
    school_name: `Mountain Peak Academy ${i + 1}`,
    school_email: `student${i + 1}@gmail.com`,
    city: `Chennai${i + 1}`,
    state: `Tamil Nadu${i + 1}`,
    board: i % 2 === 0 ? "CBSE" : "State Board",
    student_count: 1050 + i,
    contact_person: `+91 ${9876543210}`,
    class: "10th A",
    img: assets.ic_student_profile,
  }));

  const currentData = schoolList?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  const renderActivityDetails = (item) => {
    const { icon, title, noOfSchool } = item || {};
    return (
      <section className="student_activity_container">
        <section className="activity_img_wrapper">
          <img src={icon} alt="persons" />
        </section>
        <section className="total_student_wrapper">
          <h5>{title}</h5>
          <h4>{noOfSchool}</h4>
        </section>
      </section>
    );
  };

  return (
    <section className="school_manage_page_wrapper">
      <header className="school_manage_header">
        <h4>School Management</h4>
        <section className="notify_wrapper">
          <img src={assets.ic_notify_bell} alt="notification" />
        </section>
      </header>
      <section className="school_manage_content_wrapper">
        <section className="school_manage_content_main_wrapper">
          <section className="school_activity_wrapper">
            <section className="school_activity_content_wrapper">
              {STUNDET_ACTIVITY_DETAILS.map(renderActivityDetails)}
            </section>
          </section>
          <section className="top_actions_bar">
            <section className="refresh_btn" onClick={refreshData}>
              <img src={assets.ic_refetch} alt="refresh" />
              <h5>Refresh</h5>
            </section>
          </section>
        </section>

        {schools.length > 0 && (
          <section className="student_manage_active_deactive_wrapper">
            <h4>{`${schools.length} school${schools.length > 1 ? "s" : ""} selected`}</h4>
            <section className="student_manage_active_deactive_container">
              <section className="student_manage_active_wrapper">
                <img src={assets.ic_tick_white} alt="activate" />
                <h4>Activate Selected</h4>
              </section>
              <section className="student_manage_deactive_wrapper">
                <img src={assets.ic_close_white} alt="deactivate" />
                <h4>Deactivate Selected</h4>
              </section>
              <img
                src={assets.ic_close}
                alt="clear selection"
                className="clear_selection_icon"
                onClick={clearSelectedSchools}
                style={{ cursor: "pointer", opacity: 0.5 }}
              />
            </section>
          </section>
        )}
        <section className="school_manage_table_search_continer">
          <section className="school_manage_search_wrapper">
            <img src={assets.ic_search} alt="search" />
            <input
              placeholder="Search students by name or ID..."
              name="search"
              value={search}
              onChange={onChangeValue}
            />
          </section>
          <section className="school_manage_school_wrapper">
            {/* school */}
            {/* <section className="school_drop_down_container">
                          <select className="school_select">
                            <option value="">School</option>
                            <option value="school1">School 1</option>
                            <option value="school2">School 2</option>
                            <option value="school3">School 3</option>
                          </select>
                          <img src={assets.ic_chevron_down} alt="chevron_down"/>
                     </section> */}

            {/* city */}
            {/* <section className="school_drop_down_container">
                          <select className="school_select">
                            <option value="">City</option>
                            <option value="school1">Chennai</option>
                            <option value="school2">Kolkata</option>
                            <option value="school3">Bangalore</option>
                            <option value="school3">Jaipur</option>
                            <option value="school3">Hyderabad</option>
                            <option value="school3">Ahmedabad</option>
                            <option value="school3">Pune</option>
                          </select>
                          <img src={assets.ic_chevron_down} alt="chevron_down"/>
                     </section> */}

            {/* state */}
            {/* <section className="school_drop_down_container">
                          <select className="school_select">
                            <option value="">State</option>
                            <option value="school1">Tamil Nadu</option> 
                            <option value="school2">West Bengal</option>
                            <option value="school2">Karnataka</option>
                            <option value="school2">Rajasthan</option>
                            <option value="school2">Telangana</option>
                            <option value="school2">Gujarat</option>
                            <option value="school2">Kerala</option>
                          </select>
                          <img src={assets.ic_chevron_down} alt="chevron_down"/>
                     </section> */}
            {/* Board */}
            {/* <section className="school_drop_down_container">
                          <select className="school_select">
                            <option value="">Board</option>
                            <option value="school1">CBSE</option>
                            <option value="school2">State Board</option>
                          </select>
                          <img src={assets.ic_chevron_down} alt="chevron_down"/>
                     </section> */}
          </section>
        </section>
        <section className="table_container">
          {loading && (
            <div className="table_loader_overlay">
              <div className="spinner"></div>
            </div>
          )}
          <table className="school_table">
            <thead>
              {/* <tr>
                          <th></th>
                          <th>School Name</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Board</th>
                          <th>Student count</th>
                          <th>Contact person</th>
                          <th>Email</th>
                          <th>Actions</th>
                        </tr> */}
              <tr>
                <th></th>
                <th>School Name</th>
                <th>Student Count</th>
              </tr>
            </thead>
            <tbody>
              {currentData?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      checked={!!data.selectedSchools[item?.school]}
                      onChange={() => handleCheckboxChange(item?.school)}
                    />
                  </td>

                  <td>
                    <section className="school_profile_cell">
                      <img
                        src={assets.ic_persons}
                        className="school_avatar"
                        alt="profile_img"
                      />
                      <section>
                        {/* <h4 className="school_name">{item.school_name}</h4>
                                      <p className="school_email">{item.school_email}</p> */}
                        <h4 className="school_name">{item?.school}</h4>
                      </section>
                    </section>
                  </td>

                  {/* <td>{item.city}</td>
                                <td>{item.state}</td>
                                <td>{item.board}</td>
                                <td>{item.student_count}</td>
                                <td>{item.contact_person}</td>
                                <td>{item.school_email}</td>

                                <td className="action_icons">
                                  <img src={assets.ic_delete_record} alt="edit" className='edit' />
                                  <img src={assets.ic_edit} alt="delete" className='delete'/>
                                </td> */}

                  <td>{item?.student_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            totalResults={schoolList?.length}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </section>
      </section>
    </section>
  );
};
